export default "__VITE_ASSET__b0505255__"